import { Close as CloseIcon } from '@mui/icons-material';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import { UnstyledButtonWrap } from '../common.styles';

/**
 * Renders a <DialogTitle /> component.
 * @param {object} props - Any unaccounted properties will be available from restTitleProps.
 * @param {Array} props.children
 * @param {boolean} props.disableCloseIcon
 * @param {function} props.onClose
 * @param {string} props.titleId
 * @returns {React.Component}
 */
const DialogTitle = ({
  children,
  disableCloseIcon = false,
  onClose = () => {},
  titleId,
  ...restTitleProps
}) => {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        borderBottom: '1px solid',
        borderColor: 'grey.40',
        p: {
          xs: 2,
          sm: 4,
        },
      }}
      alignItems="center"
      display="flex"
      justifyContent="space-between"
      {...restTitleProps}
    >
      <Typography
        component="h1"
        id={titleId}
        variant="subtitle1"
        align="left"
      >
        {children}
      </Typography>
      {onClose && (
        !disableCloseIcon && (
        <UnstyledButtonWrap
          aria-label={t('Close')}
          title={t('Close')}
          onClick={onClose}
        >
          <CloseIcon
            sx={{
              color: 'grey.80',
            }}
            aria-hidden="true"
          />
        </UnstyledButtonWrap>
        )
      )}
    </Box>
  );
};

DialogTitle.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  onClose: PropTypes.func,
  titleId: PropTypes.string.isRequired,
  disableCloseIcon: PropTypes.bool,
};

export default DialogTitle;
